module.exports = __webpack_public_path__ + "img/expert.d4a369cf.png";